import type { FC, PropsWithChildren } from "react";
import React from "react";

import { Icon } from "../../Icon";
import { ToastCommon } from "../helper/ToastCommon";

import type {
    PropsWithCustomVarsStyles,
    PropsWithTsId,
} from "../../../types/react";
import type { IToastCommonProps } from "../helper/ToastCommon";

import classes from "./ToastAlert.styl";

const TOAST_ALERT_TEST_ID = "toast-alert-test-id";
const TOAST_ALERT_DISPLAY_NAME = "ToastAlert";

const PRESET_ICONS = {
    positive: "glyph_check_circle_on_filled_24+",
    attention: "glyph_alert_circle_filled_24+",
    negative: "glyph_alert_circle_filled_24+",
    info: "glyph_info_circle_filled_24+",
} as const;

export type ToastAlertProps = PropsWithCustomVarsStyles<
    Pick<
        IToastCommonProps,
        | "title"
        | "subtitle"
        | "preset"
        | "direction"
        | "fillHorizontal"
        | "timerDuration"
    >
> &
    Partial<PropsWithTsId>;

/**
 * Используется библиотека sonner.
 *
 * <a href="https://uikit.odkl.ru/?path=/docs/%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B-toast-%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D0%B0-toast--docs" target="_blank">Дока про использование компонента Toast</a>
 *
 * Компонент, который в виде всплывающего сообщения, отображает для пользователя информацию об изменениях в приложении и даёт возможность выполнить контекстное действие
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=2-88973&p=f&m=dev" target="_blank">Спека</a>
 * @constructor
 */

export const ToastAlert: FC<PropsWithChildren<ToastAlertProps>> = (props) => {
    const { preset = "positive", "data-tsid": tsid } = props;

    const defaultIcon = (
        <Icon
            size="24"
            icon={PRESET_ICONS[preset]}
            className={classes["icon"]}
        />
    );

    return (
        <ToastCommon
            {...props}
            data-tsid={tsid || TOAST_ALERT_TEST_ID}
            timer
            classes={classes}
            defaultIcon={defaultIcon}
            data-uikit={TOAST_ALERT_DISPLAY_NAME}
        />
    );
};

ToastAlert.displayName = "ToastAlert";
export default ToastAlert;
